import './SupportTicketDashboard.scss';
import SupportTicketList from './SupportTicketList/SupportTicketList';
import { useEffect } from 'react';

/**
 * SupportTicketDashboard Component
 *
 * @component
 * @description
 * A simple dashboard for support staff to view and manage tickets. It primarily renders
 * the 'SupportTicketList' component inside a styled container.
 *
 * @returns {JSX.Element} The support ticket dashboard layout.
 *
 * @example
 * // Usage:
 * <SupportTicketDashboard />
 */



export default function SupportTicketDashboard() {
  
  useEffect(() => {
    // Get body element and add class on mount
    document.body.classList.add("support-dashboard-active");

    return () => {
      // Cleanup: Remove the class when the component unmounts
      document.body.classList.remove("support-dashboard-active");
    };
  }, []); // run once, on mount and cleanup on unmount

  return (
    <div className="support-ticket-dashboard" data-testid="support-ticket-dashboard">
      <section>
        <SupportTicketList data-testid="support-ticket-list" />
      </section>
    </div>
  );
}
 
 
